import { render } from "./ActivityBoard.vue?vue&type=template&id=be997b6c"
import script from "./ActivityBoard.vue?vue&type=script&lang=js"
export * from "./ActivityBoard.vue?vue&type=script&lang=js"

import "./ActivityBoard.vue?vue&type=style&index=0&id=be997b6c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__